import { render } from "./WsWebhook.vue?vue&type=template&id=ab1346ee"
import script from "./WsWebhook.vue?vue&type=script&lang=js"
export * from "./WsWebhook.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__